import { render, staticRenderFns } from "./Setari.vue?vue&type=template&id=5b6b0701&scoped=true"
import script from "./Setari.vue?vue&type=script&lang=js"
export * from "./Setari.vue?vue&type=script&lang=js"
import style0 from "./Setari.vue?vue&type=style&index=0&id=5b6b0701&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6b0701",
  null
  
)

export default component.exports